export default __webpack_public_path__ + "static/media/personal-helper.1d7911c0.svg";